import type { MainPoiCategory } from '$lib/components/pois/types';
import type { Zoi } from '$lib/components/zoi/types';
import { ROUTE_ZOI } from '$lib/constants/route';
import { defaultPoiCategories } from '$lib/constants/searchParams';
import { gotoWithParams, type SearchParams } from '$lib/services/urls/searchParams';

export function gotoZoi(searchParams: SearchParams, zoi: Zoi, isElectricVehicle?: boolean) {
	let poiCategories: MainPoiCategory[];

	if (zoi.isArrivalZoi) {
		poiCategories = ['ACCOMMODATION'];
	} else {
		poiCategories = defaultPoiCategories;

		if (isElectricVehicle) {
			poiCategories.push('EV_SERVICE');
		}
	}

	gotoWithParams(ROUTE_ZOI, {
		...searchParams,
		poiCategories,
		zoi: { center: zoi.center, radius: zoi.radius },
	});
}
